export const ADDRESS_STORAGE = "address-storage"
export const POOLS_STORAGE = "pools_storage"